import { defineStore } from 'pinia'
import { api } from '@/api/client'
import type { User } from '@/types'

export const useSessionStore = defineStore('session', {
  state: (): { user: User | null; ready: boolean } => ({ user: null, ready: false }),
  actions: {
    async restore(): Promise<void> { try { this.user = (await api<{ user: User }>('/auth/me')).user } catch { this.user = null } finally { this.ready = true } },
    async login(username: string, password: string): Promise<void> { this.user = (await api<{ user: User }>('/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) })).user },
    async logout(): Promise<void> { await api('/auth/logout', { method: 'POST' }); this.user = null },
  },
})

